import {
  IMCChannelShownFields,
  MCCreateChannelResponse,
  WhatsappAuthorizationResponse,
  WhatsappChannelState,
  entities
} from '../../../api/proto';
import {randomUint8Array, uint8ArrayToUuid} from '../../../utils/arrayUtils';
import wait from '../../../utils/wait';
import Channel from '../Channel';
import {ChannelsUpdaterEvent} from '../ChannelsUpdater';
import Whatsapp from './Whatsapp/Whatsapp';


export class WhatsappEmulator extends Whatsapp {

  createChannel = async (shownFields?: IMCChannelShownFields | null) => {
    console.debug(shownFields);
    if (this.loading) {
      return {error: {message: 'In process'}, res: null};
    }

    const channelID = randomUint8Array();
    const createChannelRes = new MCCreateChannelResponse({
      channelID,
      whatsappAuthFlow: {
        status: WhatsappAuthorizationResponse.Status.OK,
        qrcode: uint8ArrayToUuid(channelID),
      },
    });

    let newChannel: Channel | null = null;

    if (createChannelRes) {
      newChannel = new Channel(
        {
          channelID: createChannelRes?.channelID,
          shownFields: shownFields,
          type: entities.OzekonChannelType.OIT_WHATSAPP,
          workspaceID: this.channels.workspace.id,
          state: {
            whatsapp: {
              state: WhatsappChannelState.State.CREATE_CHANNEL,
            },
          },
        },
        this.channels.workspace,
      );
    }

    this.setLoading(true);
    await wait(1000);
    this.setLoading(false);

    this.emulateQrCodeScan(newChannel);

    return {error: null, res: createChannelRes, channel: newChannel};
  };

  private emulateQrCodeScan = async (newChannel: Channel | null) => {
    await wait(1000);
    this.emulateChannelsLoad(newChannel);
    await wait(5000);
    this.emulateUpdateEvent(newChannel);
  };

  private emulateChannelsLoad = (newChannel: Channel | null) => {
    console.debug('emulateChannelsLoad');
    newChannel && this.channels.setChannels([
      ...this.channels.list,
      new Channel(
        {
          channelID: newChannel?.id,
          shownFields: newChannel.shownFields,
          type: newChannel.type,
          workspaceID: newChannel.workspace.id,
          state: {
            whatsapp: {
              state: WhatsappChannelState.State.CREATE_CHANNEL,
            },
          },
        },
        this.channels.workspace,
      ),
    ]);
  };

  private emulateUpdateEvent = (newChannel: Channel | null) => {
    console.debug('emulateUpdateEvent');
    this.channels.workspace.updater.emit(ChannelsUpdaterEvent.UPDATE, {
      channelID: newChannel?.id,
      updateChannelState: {
        newState: {
          whatsapp: {
            state: WhatsappChannelState.State.EVENT_LISTENING,
          },
          identifiers: {
            phone: '+101234567890',
          },
        },
      },
    },
    );
  };
}

export default WhatsappEmulator;
